// GDPR-safe random Danish animal + electricity nickname generator for leaderboard

// Danish animals only — safe, recognizable, no double meanings
const animals = [
  'Ørn', 'Hval', 'Bjørn', 'Ulv', 'Falk', 'Delfin', 'Egern', 'Ugle',
  'Hare', 'Ravn', 'Svale', 'Laks', 'Odder', 'Stork', 'Bæver',
  'Hjort', 'Spurv', 'Fugl', 'Gedde', 'Torsk',
  'Sæl', 'Fasan', 'Dåhjort', 'Grævling', 'Isfugl', 'Havørn'
];

// Electricity/energy themed Danish adjectives — all safe, no profanity risk
const elAdjectives = [
  'Lynhurtig', 'Energisk', 'Strøm', 'Volt', 'Watt', 'Ampere',
  'Turbo', 'Lade', 'Solar', 'Grøn', 'Elektro', 'Kvikt',
  'Flash', 'Boost', 'Gnist', 'Puls', 'Neon', 'Kraft',
  'Glow', 'Zap', 'Flux', 'Ohm', 'Jord'
];

// Blocked combinations — substrings that should never appear in the final name (lowercase check)
const BLOCKED_SUBSTRINGS = [
  'anal', 'anus', 'pik', 'fisse', 'lort', 'svin', 'nazi', 'hitler',
  'idiot', 'homo', 'bøsse', 'luder', 'hore', 'knep', 'fag', 'piss',
  'shit', 'fuck', 'damn', 'slut', 'porn', 'cock', 'dick', 'cunt',
  'ass', 'rape', 'hate', 'kill', 'die', 'dead', 'sex', 'cum',
  'whore', 'bitch', 'negro', 'nigger', 'retard'
];

function isSafe(name) {
  const lower = name.toLowerCase().replace(/\s/g, '');
  return !BLOCKED_SUBSTRINGS.some(bad => lower.includes(bad));
}

export function generateNickname() {
  // Try up to 20 times to get a safe combo
  for (let i = 0; i < 20; i++) {
    const adj = elAdjectives[Math.floor(Math.random() * elAdjectives.length)];
    const animal = animals[Math.floor(Math.random() * animals.length)];
    const num = Math.floor(Math.random() * 99) + 1;
    const name = `${adj} ${animal} ${num}`;
    if (isSafe(name)) return name;
  }
  // Fallback — guaranteed safe
  return `Grøn Ørn ${Math.floor(Math.random() * 99) + 1}`;
}